module.exports = __webpack_public_path__ + "media/images/alteryx-homepage-scaled-a0d7eee20513ea17ea539064d25b01390fe8dc9404258a9d5808ddb2ed83dabb.jpg";